import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import { TypedQuery } from "../queries";
import {
  CountMotherOrders,
  CountMotherOrdersVariables
} from "./types/CountMotherOrders";
import {
  CountStoreOrders,
  CountStoreOrdersVariables
} from "./types/CountStoreOrders";
import { Home, HomeVariables } from "./types/Home";
import { SalesToday, SalesTodayVariables } from "./types/SalesToday";
import { TopProducts, TopProductsVariables } from "./types/TopProducts";

const home = gql`
  query Home($tenantId: ID) {
    storeOrders(filter: { smopStatus: NEW_ORDER }) {
      totalCount
    }
    storeOrdersTotal(period: TODAY, tenantId: $tenantId) {
      currency
      gross {
        currency
        amount
      }
    }
    productTopToday: reportProductSales(period: TODAY, first: 5) {
      edges {
        node {
          id
          revenue(period: TODAY) {
            gross {
              amount
              currency
            }
          }
          attributes {
            values {
              id
              name
            }
          }
          product {
            id
            name
            thumbnail {
              url
            }
          }
          quantityOrdered
        }
      }
    }
  }
`;
export const HomePageQuery = TypedQuery<Home, HomeVariables>(home);

const salesToday = gql`
  query SalesToday($tenantId: ID) {
    storeOrdersTotal(period: TODAY, tenantId: $tenantId) {
      currency
      gross {
        currency
        amount
      }
    }
  }
`;
export const useSalesTodayQuery = makeQuery<SalesToday, SalesTodayVariables>(
  salesToday
);

const countStoreOrders = gql`
  query CountStoreOrders($filter: StoreOrderFilterInput) {
    storeOrders(filter: $filter) {
      totalCount
    }
  }
`;
export const useCountStoreOrders = makeQuery<
  CountStoreOrders,
  CountStoreOrdersVariables
>(countStoreOrders);

const countMotherOrders = gql`
  query CountMotherOrders($filter: OrderFilterInput) {
    orders(filter: $filter) {
      totalCount
    }
  }
`;
export const useCountMotherOrders = makeQuery<
  CountMotherOrders,
  CountMotherOrdersVariables
>(countMotherOrders);

const topProducts = gql`
  query TopProducts($tenantId: ID) {
    reportProductSales(last: 5, period: TODAY, tenantId: $tenantId) {
      edges {
        node {
          attributes {
            values {
              name
            }
          }
          id
          revenue(period: TODAY) {
            gross {
              amount
              currency
            }
          }
          product {
            id
            name
            thumbnail {
              url
            }
          }
          quantityOrdered
        }
      }
    }
  }
`;
export const useTopProducts = makeQuery<TopProducts, TopProductsVariables>(
  topProducts
);
